import { ArrowDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { PricingToggle } from "@/components/aziende/PricingToggle";
import { PricingCard } from "@/components/aziende/PricingCard";
import { PLANS, CONTACT_EMAIL } from "@/components/aziende/plans";
import { PromoBanner } from "@/components/aziende/Promo";
import { scrollToId } from "@/lib/scroll";

export const JumpLink = ({ to, children, testId, className = "" }) => (
  <a
    href={`#${to}`}
    onClick={(e) => {
      e.preventDefault();
      scrollToId(to);
    }}
    className={`jump-pill group inline-flex min-h-[44px] items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-medium text-white ${className}`}
    data-testid={testId}
  >
    {children}
    <ArrowDown className="h-4 w-4 text-cyan transition-transform duration-300 group-hover:translate-y-0.5" />
  </a>
);

export const Piani = ({ pcto, setPcto }) => (
  <section id="piani" className="relative px-6 pt-36 pb-20 lg:pt-48 lg:pb-32 scroll-mt-24" data-testid="piani-section">
    <div className="max-w-[1320px] mx-auto">
      <Reveal className="text-center max-w-3xl mx-auto mb-14 lg:mb-20">
        <Eyebrow className="mb-6">Piani e Prezzi</Eyebrow>
        <h1 className="font-extrabold tracking-[-0.04em] leading-[1.04] text-4xl sm:text-5xl lg:text-6xl" data-testid="piani-title">
          Scegli l'infrastruttura giusta per la tua azienda.
        </h1>
        <p className="mt-6 mx-auto max-w-[60ch] text-base sm:text-lg leading-relaxed text-titanium" data-testid="piani-subtitle">
          Supporta il futuro: aderendo alla Formazione Scuola-Lavoro (ex PCTO) e ospitando gli istituti, sblocchi tariffe agevolate esclusive.
        </p>
        <JumpLink to="calcolatore" testId="piani-calc-jump" className="mt-8">
          Non sai quale scegliere? Calcola il tuo risparmio
        </JumpLink>
        <PricingToggle pcto={pcto} onChange={setPcto} />
      </Reveal>
      <Reveal>
        <PromoBanner />
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 min-[1200px]:grid-cols-4 gap-5">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.id} delay={i * 100} className="h-full">
            <PricingCard plan={plan} pcto={pcto} />
          </Reveal>
        ))}
      </div>
      <Reveal>
        <p className="mt-14 mx-auto max-w-3xl text-center text-sm leading-relaxed text-titanium" data-testid="piani-footnote">
          Prezzi IVA esclusa. Lo sconto ospitalità Formazione Scuola-Lavoro (ex PCTO) è riservato alle aziende che mettono a disposizione date di visita per gli istituti. Puoi cambiare pacchetto in qualsiasi momento con addebito pro-rata della differenza.
        </p>
        <p className="mt-4 text-center text-sm text-[#6b7078]" data-testid="piani-contact-note">
          Per informazioni scrivici direttamente a{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link inline-block py-2 text-titanium underline underline-offset-4 decoration-[#2a2d33]" data-testid="piani-email-link">
            {CONTACT_EMAIL}
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);
